import { EmailSubscriptionEffects } from './email-subscription.effects';
import { PromoEffects } from './promo.effects';

export const effects: any[] = [EmailSubscriptionEffects, PromoEffects];
